import React, { useEffect, useState } from "react";
import { getUsersList } from '../../api/apiHandler';
import { showErrorMessage } from "../common/Utils";

export function Userslist() {

    const [usersList, setusersList] = useState([]);
    
    useEffect(() => {
        async function getAppData() {
            const contentReq = {}
            const response = await getUsersList(contentReq);
            if (parseInt(response.code) === 1) {
                setusersList(response.data);
            } else {
                showErrorMessage(response.message);
            }
        }
        getAppData();
    }, []);

    return (
        <>
            <div className="p-6">
                <h3 className="text-center text-2xl font-bold mb-4">User List</h3>
                <hr/>
                <div className="overflow-x-auto">
                    <table border="1" className="table-auto w-full border-collapse border border-gray-400">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="border border-gray-400 px-4 py-2 text-left">#</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">LOGIN TYPE</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">SOCIAL ID</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">SYNTEL UID</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">ACCOUNT CODE</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">FIRST NAME</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">LAST NAME</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">EMAIL</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">COUNTRY CODE</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">PHONE</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">BALANCE</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">IS PIN SET</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">IS KYC COMPLETED</th>
                                <th className="border border-gray-400 px-4 py-2 text-left">KYC STATUS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {usersList && usersList.map((user) => (
                                <tr key={user.user_id} className="hover:bg-gray-50">
                                    <td className="border border-gray-400 px-4 py-2">{user.user_id}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.login_type}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.social_id}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.syntel_uid}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.account_code}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.first_name}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.last_name}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.email}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.country_code}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.phone}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.balance}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.is_pin_set}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.is_kyc_completed}</td>
                                    <td className="border border-gray-400 px-4 py-2">{user.kyc_status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}